/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import * as React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";

import Card from "../../../reusable/cardv2";
import EditChargebeeInfoIcon from "../../../reusable/editChargebeeInfoIcon";
import { ContactInfoCardPropTypes } from "../lib/types";
import { StyledParagraph } from "../lib/styles";

const ContactInfoCard = ({
  companyName,
  email,
  fetchData,
  loading,
  openPortal,
  phone,
}: ContactInfoCardPropTypes): React.ReactElement => {
  return (
    <Card
      loading={loading}
      testId="contact-info"
      subtitle={i18n.translate("title.account_details")}
    >
      <EditChargebeeInfoIcon
        altText={i18n.translate(
          "admin_pages.settings.billing.edit_contact_info"
        )}
        closeModalCallback={(): void => {
          return fetchData("contact");
        }}
        openPortal={openPortal}
        portalSection="ACCOUNT_DETAILS"
        testId="contact-info-edit-icon"
        amplitudeEventName="Billing Settings: Contact Info"
      />
      {companyName && (
        <StyledParagraph data-testid="company-name">
          {companyName}
        </StyledParagraph>
      )}
      {email && <StyledParagraph data-testid="email">{email}</StyledParagraph>}
      {phone && <StyledParagraph data-testid="phone">{phone}</StyledParagraph>}
      {!companyName && !email && !phone && (
        <StyledParagraph data-testid="no-contact-info">
          {i18n.translate("admin_pages.settings.billing.no_contact_info")}
        </StyledParagraph>
      )}
    </Card>
  );
};

export default ContactInfoCard;
